export function needsUserSetup(registro) {
  if (typeof registro === "boolean") return registro === false;
  if (registro === 0) return true;
  if (registro === 1) return false;
  if (registro == null) return true; 
  const str = String(registro).trim().toLowerCase();
  if (str === "true" || str === "1") return false;
  if (str === "false" || str === "0") return true;
  return true;
}
/**
 * VIVA-1019: true SOLO cuando el login dice explicitamente que el alta quedo
 * pendiente. Un `registro` ausente NO cuenta como pendiente, y esa es toda la
 * correccion: el 2026-08-28 el backend recorto el objeto `user` de
 * /api/sec/login/externo y dejo de mandar `registro` (junto con genero, nacionalidad,
 * ocupacion, email, fechaRegistro, estatus e idTipoUsuario). Google y Wizzard
 * preguntaban `!registro`, asi que leian el campo ausente como "le falta el alta" y
 * mandaban a #/user_setup a cuentas ya registradas. Apple y Microsoft nunca lo
 * sufrieron porque ya comparaban contra `false`.
 *
 * OJO: esto NO es needsUserSetup. Esa funcion trata el campo ausente como alta
 * pendiente, que con el payload de hoy es justo la respuesta equivocada. Se conserva
 * porque la usa SSO.jsx, que es codigo muerto.
 */
export const altaExplicitamentePendiente = (registro) =>
  registro === false ||
  registro === 0 ||
  registro === "false" ||
  registro === "0";
